/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportExcelStationTransactions } from '../fn/transactions/export-excel-station-transactions';
import { ExportExcelStationTransactions$Params } from '../fn/transactions/export-excel-station-transactions';
import { exportExcelSubscriptionTransactions } from '../fn/transactions/export-excel-subscription-transactions';
import { ExportExcelSubscriptionTransactions$Params } from '../fn/transactions/export-excel-subscription-transactions';
import { exportExcelTransactions } from '../fn/transactions/export-excel-transactions';
import { ExportExcelTransactions$Params } from '../fn/transactions/export-excel-transactions';
import { getTransactionDashboard } from '../fn/transactions/get-transaction-dashboard';
import { GetTransactionDashboard$Params } from '../fn/transactions/get-transaction-dashboard';
import { TransactionDashboardCount } from '../models/transaction-dashboard-count';

@Injectable({ providedIn: 'root' })
export class TransactionsService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTransactionDashboard()` */
  static readonly GetTransactionDashboardPath = '/custom/transactions/dashboard';

  /**
   * Get transactions dashboard.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransactionDashboard()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionDashboard$Response(params: GetTransactionDashboard$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionDashboardCount>> {
    return getTransactionDashboard(this.http, this.rootUrl, params, context);
  }

  /**
   * Get transactions dashboard.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransactionDashboard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionDashboard(params: GetTransactionDashboard$Params, context?: HttpContext): Observable<TransactionDashboardCount> {
    return this.getTransactionDashboard$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionDashboardCount>): TransactionDashboardCount => r.body)
    );
  }

  /** Path part for operation `exportExcelTransactions()` */
  static readonly ExportExcelTransactionsPath = '/custom/transactions/export';

  /**
   * Export transactions.
   *
   * Allows to export all the transactions as an XLSX File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportExcelTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportExcelTransactions$Response(params: ExportExcelTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportExcelTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Export transactions.
   *
   * Allows to export all the transactions as an XLSX File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportExcelTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportExcelTransactions(params: ExportExcelTransactions$Params, context?: HttpContext): Observable<Blob> {
    return this.exportExcelTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportExcelStationTransactions()` */
  static readonly ExportExcelStationTransactionsPath = '/custom/stations/{uid}/transactions/export';

  /**
   * Export the transactions assigned to this station.
   *
   * Allows to export the station's transactions as an XLSX File
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportExcelStationTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportExcelStationTransactions$Response(params: ExportExcelStationTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportExcelStationTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the transactions assigned to this station.
   *
   * Allows to export the station's transactions as an XLSX File
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportExcelStationTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportExcelStationTransactions(params: ExportExcelStationTransactions$Params, context?: HttpContext): Observable<Blob> {
    return this.exportExcelStationTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportExcelSubscriptionTransactions()` */
  static readonly ExportExcelSubscriptionTransactionsPath = '/custom/subscriptions/{uid}/transactions/export';

  /**
   * Export transactions for a subrciption into XLS format.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportExcelSubscriptionTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportExcelSubscriptionTransactions$Response(params: ExportExcelSubscriptionTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportExcelSubscriptionTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Export transactions for a subrciption into XLS format.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportExcelSubscriptionTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportExcelSubscriptionTransactions(params: ExportExcelSubscriptionTransactions$Params, context?: HttpContext): Observable<Blob> {
    return this.exportExcelSubscriptionTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
